export default (theme) => ({
  accessContacts: {
    textAlign: 'center',
    marginTop: 30,
    paddingBottom: 30,
  },
  guideLink: {
    textDecoration: 'none',
    textTransform: 'lowercase',
    color: theme.palette.link.main,
  },
});
